import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { ConfirmationPage } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getRewardsAccountWithLargestValue,
  getSelectedAccountReferenceIdIfRedemptionEnabled,
} from "../../../rewards/reducer";
import { getFromDate, getUntilDate } from "../../../search/reducer";

export const mapStateToProps = (state: IStoreState) => ({
  largestValueAccount: getRewardsAccountWithLargestValue(state),
  rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
});

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ConfirmationPageConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedConfirmationPage = withRouter(
  connector(ConfirmationPage)
);
